import React, { useState } from 'react';
import {
    Grid,
    Box,
    Typography,
    Divider,
    Input,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
} from '@mui/material';
import { CloseIcon, ExternalLinkIcon } from '../../../assets';
import { connectedApp } from '../../../assets/connected-apps';
import { CustomButton, CustomModal, CustomSwitch } from '../../shared';
import { useDispatch, useSelector } from 'react-redux';
import { markToTestAuth, salesforceAuthorize, salesforceoceAuthorize, saveMarkToTestAuth } from '../../../redux/thunks/customerSettingsThunk';
import FlowSettings from './flowSettings';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm, useController } from 'react-hook-form';

const initialValue =  {
    munchkinId: "",
    clientId: "",
    clientServer: "",
};

const marketoConnection = yup.object().shape({
    munchkinId: yup.string().required('Please Enter Munchkin Id'),
    clientId: yup.string().required('Please Enter Client Id'),
    clientServer: yup.string().required('Please Enter Client Secret'),
});
const ConnectedApps = (props) => {
    const { } = props;
    const [open, setOpen] = useState(false)
    const [openLogin, setLoginOpen] = useState(false)
    const { CONNECTED_APPS } = useSelector((state) => state.customerSettings);
    const [connectedApps, setConnectedApps] = useState(CONNECTED_APPS);
    const dispatch = useDispatch()
    const { company } = useSelector(state => state.company)
    const { register, handleSubmit, setValue, getValues, formState: { errors }, control, } = useForm({ resolver: yupResolver(marketoConnection), defaultValues: initialValue });
    const handleShowModal = () => {
        setOpen(!open)
    }
    const handleLoginClose = () =>{
        setLoginOpen(!openLogin);
    }
const handleLogin  = () =>{
    setLoginOpen(!openLogin)
}
    const handleConnectedAppLogo = (name) => {
        const appName = name?.toLowerCase();
        for (const app in connectedApp) {
            if (appName.includes(app)) {
                return connectedApp[app];
            }
        }
        return null;
    };

    const handleConnectedApps = (appName) => {

        if(appName === "Veeva" || appName === 'Salesforce Marketing Cloud' ){
            dispatch(salesforceAuthorize({companyId: company.id}))
        }
        else if(appName === 'IQVIA OCE'){
            dispatch(salesforceoceAuthorize({companyId: company.id}))
        }
        else if(appName === 'AdLib DSP Advertising'){
            window.location.href = "https://app.adlibdsp.com/dashboard"
        }

        const appIndex = connectedApps.findIndex(app => app.appName === appName);

        if (appIndex !== -1) {
            const updatedConnectedApps = [...connectedApps];
            updatedConnectedApps[appIndex] = {
                ...updatedConnectedApps[appIndex],
                isConnected: !updatedConnectedApps[appIndex].isConnected,
            };

            setConnectedApps(updatedConnectedApps);
        }
    };
const onSubmit = (data)=>{
    dispatch(markToTestAuth({companyId: company.id,data:data }))
}
    const handleTest = () => {
        handleSubmit(onSubmit);
    };

    const handleSave = () =>{
        const data = {
            munchkinId: getValues("munchkinId"), 
            clientId: getValues("clientId"),
            clientSecret: getValues("clientServer")
        }
        if(data.clientId !==""){
            dispatch(saveMarkToTestAuth({companyId: company.id, data: data}));
        }
    }

           

    return (
        <Box className="">
            <Box className="pb-24px">
                <Box className="pb-24px">
                    <Typography className='text-lg-medium gray-900'>Connected apps</Typography>
                    <Typography className='text-sm-regular gray-500'>Supercharge your workflow and connect the tool you use every day.</Typography>
                </Box>
                <Box className="note-container pb-24px">
                    <Box className="flex-row-center-start gap-6">
                        <Typography className="text-md-medium gray-900">
                            Note:
                        </Typography>
                        <Typography className="text-md-regular gray-500">
                            The current query definition does not provide any valid results. Please revise your query parameters.
                        </Typography>
                    </Box>
                    <Box className="padding-10px icon">
                        <CloseIcon color="#98A2B3" width='15' height='15' />
                    </Box>

                </Box>
            </Box>
            <Grid container spacing={'24px'}>
                {connectedApps?.map((app) => {
                    let { appName, subTitle, isConnected } = app;
                    return (<Grid item xs={4}>
                        <Box className="connected-app-card-container height-100">
                            <Box className="padding-16px height-60">
                                <Box className="flex-row-space-between-start">
                                    <Box className="flex-row-center gap-12">
                                        <img
                                            src={handleConnectedAppLogo(appName)}
                                            width="42px"
                                            height="42px"
                                            alt={appName}
                                        />
                                        <Typography className='text-md-medium gray-900'>{appName}</Typography>
                                    </Box>
                                    <Box onClick={()=>setOpen(!open)} className="cursor-pointer">
                                        <img src={ExternalLinkIcon} width={'18px'} height={'18px'} />
                                    </Box>
                                </Box>
                                <Box className="pt-24px pb-20px">
                                    <Typography className='text-sm-regular gray-500'>
                                        {subTitle}
                                    </Typography>
                                </Box>
                            </Box>
                            <Divider className='border-1-gray' />
                            <Box className="flex-row-space-between-center padding-tb-16-rl-24">
                                <Typography className={`text-sm-regular ${isConnected ? 'primary-600' : 'error-700'}`}>
                                    {isConnected ? 'Connect' : 'Disconnect'}
                                </Typography>
                                <CustomSwitch
                                    checked={isConnected}
                                    onChange={() =>appName === "Marketo" ? handleLogin() : handleConnectedApps(appName)}
                                />
                            </Box>
                        </Box>
                    </Grid>)
                })}
            </Grid>
            <CustomModal modalOpen={open} backgroundColor={"white"} component={<FlowSettings open={open} handleClose={handleShowModal} onClose={handleShowModal} />} />
            <Dialog open={openLogin} onClose={handleLoginClose}>
                <DialogTitle>Adobe Marketo Authentication</DialogTitle>
                <Divider />
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent>
                        <Box>
                            <Box className="flex-row-space-between-center gap-24">
                                <Typography>
                                    Munchkin Id:
                                </Typography>
                                <Box>
                                    <TextField variant="standard" type='text'  {...register('munchkinId')} error={!!errors.munchkinId?.message} helperText={errors.munchkinId?.message} />
                                </Box>
                            </Box>
                        </Box>
                        <Box>
                            <Box className="flex-row-space-between-center gap-24">
                                <Typography>
                                    Client Id:
                                </Typography>
                                <Box>
                                    <TextField variant="standard" type='text'  {...register('clientId')} error={!!errors.clientId?.message} helperText={errors.clientId?.message} />
                                </Box>
                            </Box>
                        </Box>
                        <Box>
                            <Box className="flex-row-space-between-center gap-24">
                                <Typography>
                                    Client Secret:
                                </Typography>
                                <Box>
                                    <TextField variant="standard" type='text'  {...register('clientServer')} error={!!errors.clientServer?.message} helperText={errors.clientServer?.message} />
                                </Box>
                            </Box>
                        </Box>

                    </DialogContent>
                    <Divider />
                    <DialogActions>

                        <CustomButton
                            title="Test Connection"
                            titleColor="#FFFFFF"
                            buttonColor="#AD509E"
                            handleClick={handleTest}
                            type="submit"
                        />
                        <CustomButton
                            title="Save"
                            titleColor="#FFFFFF"
                            buttonColor="#AD509E"
                            handleClick={handleSave}
                        />
                        <CustomButton
                            title="Cancel"
                            handleClick={handleLoginClose}
                        />
                    </DialogActions>
                </form>
            </Dialog>
        </Box>
    )
}

export default ConnectedApps;
